import * as React from 'react';
import FiltersContainerView from '../../views/buy-tickets-filters-container.view';
import { ICalendarAppBaseText } from '../../classes/buytickets-text';
import { IBuyTicketsAppState } from '../../redux-state';
import { connect } from 'react-redux';
import { findDOMNode } from 'react-dom';

import A11yDialog = require('a11y-dialog');

interface StateToProps {
    text: ICalendarAppBaseText;
    filtersAlwaysModal: boolean;
}

interface ModalControlMethods {
    showModal: () => void;
    hideModal: () => void;
}

export type FiltersContainerProps = StateToProps;
export type FiltersContainerViewProps = FiltersContainerProps & ModalControlMethods;

export class FiltersContainerBase extends React.Component<FiltersContainerProps, null> implements ModalControlMethods {
    private dialog;

    constructor(props: FiltersContainerProps) {
        super(props);
    }

    initializeModal() {

        if (this.dialog) {
            this.dialog.create();
        } else {
            const element = findDOMNode(this) as any;
            this.dialog = new A11yDialog(element);
        }
    }

    destroyModal() {
        if (this.dialog) {
            // Hide the dialog, then unbind all listeners and finally set to null.
            this.dialog.destroy();
        }
    }

    componentDidMount() {
        if (this.props.filtersAlwaysModal) {
            this.initializeModal();
        }
    }

    componentDidUpdate(prevProps: FiltersContainerProps) {
        if (!this.props.filtersAlwaysModal) {
            this.destroyModal();
        }
    }

    componentWillUnmount() {
        this.destroyModal();
    }

    showModal() {
        if (this.dialog) {
            this.dialog.show();
        }
    }

    hideModal() {
        if (this.dialog) {
            this.dialog.hide();
        }
    }

    render() {
        return <FiltersContainerView {...this.props} showModal={this.showModal.bind(this)} hideModal={this.hideModal.bind(this)} />;
    }
}

function mapStateToProps(state: IBuyTicketsAppState): StateToProps {
    return {
        text: state.calendarText,
        filtersAlwaysModal: state.calendarSettings.filtersAlwaysModal
    }
}

export default connect(mapStateToProps)(FiltersContainerBase);